import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

function EditModal(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const id = props?.item?.id;
  const amountt = props?.item?.deposit_amount;
  console.log("amountt", amountt);

  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState(amountt);
  // Handler functions for updating account information

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let data = {
      topup_amount: amount,
      id: id,
    };
    // console.log('handleSubmit', data)
    props.onSubmit(data);
  };

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  return (
    <Modal isOpen={true} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>
        Update & Confirm Deposit{" "}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="title">Deposit Amount</Label>
            <Input
              type="text"
              name="title"
              id="title"
              value={amount}
              onChange={handleAmountChange}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default EditModal;
